import React from 'react'
import { APPCONFIG } from '../../../app.config';
import { RedirectExternalUrl } from '@laramie/ui';
export default function PrivateRoute(props) {
  return (
    (props.isAuthenticated)
    ? ( props.component )
    : ( <RedirectExternalUrl location={ APPCONFIG.SITE.WEBAPP_PRINCIPAL + 'logout' }></RedirectExternalUrl> )
  )
}
